/**
 * Sound vs toast/desktop policy for inbox customer messages.
 * Sound plays for every distinct message; the session window only suppresses
 * toast/desktop, not audio.
 */
export class InboxMessageSoundPolicy {
  /**
   * @param {{
   *   soundEnabled?: boolean,
   *   isDuplicateMessage?: boolean,
   *   viewingThisChat?: boolean,
   * }} opts
   */
  decideCustomerMessage({
    soundEnabled = true,
    isDuplicateMessage = false,
    viewingThisChat = false,
  } = {}) {
    if (isDuplicateMessage) {
      return { playSound: false, showToast: false, showDesktop: false };
    }
    return {
      playSound: Boolean(soundEnabled),
      showToast: !viewingThisChat,
      showDesktop: !viewingThisChat,
    };
  }
}
